module.exports = __webpack_public_path__ + "img/Training_courses_img_2.9545d650.jpg";